export default "__VITE_ASSET__aNtcVYx6__"